/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  const grid = document.querySelector('.product-grid'); // sesuaikan

  if (grid) {
    const observer = new MutationObserver(() => {
      updateProductCount();
    });

    observer.observe(grid, {
      childList: true,
      subtree: true
    });
  }

  function updateProductCount() {
    const products = document.querySelectorAll('.product-card, .grid__item'); // sesuaikan
    const countEl = document.querySelector('#product-count');

    if (countEl) {
      countEl.innerText = products.length + ' products';
    }
  }

class SimpleGridSlider extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.slider = this.querySelector('.slider');
    this.slides = [...this.querySelectorAll('.slide')];

    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (!this.slider || !this.slides.length) return;

    this.createArrows();
    this.checkOverflow();
    this.initDrag();

    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.checkOverflow();
  }

  createArrows() {
    if (this.querySelector('.slider-arrows')) return;

    const arrows = document.createElement('div');

    arrows.className = 'slider-arrows';

    arrows.innerHTML = `
      <button class="slider-arrow prev">←</button>
      <button class="slider-arrow next">→</button>
    `;

    this.appendChild(arrows);

    this.prevButton = arrows.querySelector('.prev');
    this.nextButton = arrows.querySelector('.next');

    this.prevButton.addEventListener('click', () => {
      this.scrollByAmount(-1);
    });

    this.nextButton.addEventListener('click', () => {
      this.scrollByAmount(1);
    });
  }

  scrollByAmount(direction) {
    const slide = this.slides[0];

    if (!slide) return;

    const amount = slide.clientWidth + 20;

    this.slider.scrollBy({
      left: amount * direction,
      behavior: 'smooth',
    });
  }

  checkOverflow() {
    const hasOverflow =
      this.slider.scrollWidth > this.slider.clientWidth;

    if (this.prevButton && this.nextButton) {
      this.prevButton.style.display = hasOverflow ? '' : 'none';
      this.nextButton.style.display = hasOverflow ? '' : 'none';
    }
  }

  initDrag() {
    this.slider.addEventListener('mousedown', (e) => {
      this.isDown = true;

      this.slider.classList.add('is-dragging');

      this.startX = e.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('mouseleave', () => {
      this.isDown = false;
      this.slider.classList.remove('is-dragging');
    });

    this.slider.addEventListener('mouseup', () => {
      this.isDown = false;
      this.slider.classList.remove('is-dragging');
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (!this.isDown) return;

      e.preventDefault();

      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - this.startX) * 1.5;

      this.slider.scrollLeft = this.scrollLeft - walk;
    });
  }
}

customElements.define('simple-grid-slider', SimpleGridSlider);



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
